import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PiCheckCircle,
  PiClock,
  PiCopy,
  PiHourglass,
  PiMinusCircle,
  PiProhibit,
  PiQuestionMark,
  PiTrash,
  PiWarning,
  PiXCircle,
} from 'react-icons/pi';
import { TRACK_FINGERPRINT_SUBMISSION_STATUS } from 'services/tracks/types';
import { IColorProp } from 'types/components/components.interface';
import { ILabeledStatusProps } from './LabeledStatus';

interface ILabeledFingerprintSubmissionStatusParams extends IColorProp {
  status: TRACK_FINGERPRINT_SUBMISSION_STATUS;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledFingerprintSubmissionStatusParams[] = [
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.waitingToSubmit,
    color: 'black',
    icon: <PiClock />,
  },
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.pending,
    color: 'blue',
    icon: <PiHourglass />,
  },
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.imported,
    color: 'green',
    icon: <PiCheckCircle />,
  },
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.duplicate,
    color: 'orange',
    icon: <PiCopy />,
  },
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.rejected,
    color: 'red',
    icon: <PiXCircle />,
  },
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.disabled,
    color: 'gray',
    icon: <PiProhibit />,
  },
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.deleted,
    color: 'gray',
    icon: <PiTrash />,
  },
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.error,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: TRACK_FINGERPRINT_SUBMISSION_STATUS.notEligibleForSubmit,
    color: 'orange',
    icon: <PiMinusCircle />,
  },
];

const LabeledFingerprintSubmissionStatus = ({
  status,
}: ILabeledStatusProps<TRACK_FINGERPRINT_SUBMISSION_STATUS>) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ?? {
      color: 'gray' as const,
      icon: <PiQuestionMark />,
      status,
    };

  const statusKey =
    TRACK_FINGERPRINT_SUBMISSION_STATUS[labeledParams.status] ?? 'unknown';

  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`enum.TRACK_FINGERPRINT_SUBMISSION_STATUS.${statusKey}`)}>
      {labeledParams.icon}{' '}
      {t(`enum.TRACK_FINGERPRINT_SUBMISSION_STATUS.${statusKey}`)}
    </Label>
  );
};

export default LabeledFingerprintSubmissionStatus;
